import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../hooks";
import React from "react";
import { Sidebar } from "../components/sidebar/Sidebar";
import { Header } from "../components";
import { useMobileLayout } from "../hooks/useMobileLayout";
import { getTitleFromPath } from "../config/routeTitles";
import styles from "./ProtectedLayout.module.scss";

function ProtectedLayout() {
    const { user } = useAuth();
    const location = useLocation();
    const { 
        isSidebarOpen, 
        isMobile, 
        toggleSidebar, 
        closeSidebar, 
        isMobileMenuOpen,
        layoutClassName 
    } = useMobileLayout();
    const currentTitle = getTitleFromPath(location.pathname);

    if (!user) {
        return <Navigate to="/" />;
    }

    const renderContent = () => (
        <>
            <Header
                currentPage={currentTitle}
                onHamburgerClick={toggleSidebar}
                isSidebarOpen={isSidebarOpen}
            />
            <main>
                <Outlet />
            </main>
        </>
    );

    return (
        <div className={`${styles.protectedLayout} ${styles[layoutClassName]}`}>
            <Sidebar 
                user={user} 
                isMobileMenuOpen={isMobileMenuOpen} 
                onClose={closeSidebar}
            />
            <div className={`${styles.mainContent}${isMobile ? ' ' + styles.mobile : ''}`}>
                {renderContent()}
            </div>
        </div>
    );
}

export { ProtectedLayout };
